type IconProps = {
  size: 'xs' | 'sm';
};

export const StatementVoidIcon = ({ size }: IconProps) => (
  <svg
    width={size === 'xs' ? 12 : 16}
    height={size === 'xs' ? 13 : 17}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.833344 8.50009C0.833344 4.54202 4.04199 1.33337 8.00006 1.33337C11.9581 1.33337 15.1668 4.54202 15.1668 8.50009C15.1668 12.4582 11.9581 15.6668 8.00006 15.6668C4.04199 15.6668 0.833344 12.4582 0.833344 8.50009ZM6.3536 6.14652C6.15834 5.95126 5.84175 5.95126 5.64649 6.14652C5.45123 6.34178 5.45123 6.65837 5.64649 6.85363L7.29295 8.50009L5.64649 10.1465C5.45123 10.3418 5.45123 10.6584 5.64649 10.8537C5.84175 11.0489 6.15834 11.0489 6.3536 10.8537L8.00006 9.2072L9.64652 10.8537C9.84178 11.0489 10.1584 11.0489 10.3536 10.8537C10.5489 10.6584 10.5489 10.3418 10.3536 10.1465L8.70716 8.50009L10.3536 6.85363C10.5489 6.65837 10.5489 6.34178 10.3536 6.14652C10.1584 5.95126 9.84178 5.95126 9.64652 6.14652L8.00006 7.79298L6.3536 6.14652Z"
      fill="#A3A3A3"
    />
  </svg>
);

export const StatementDraftIcon = ({ size }: IconProps) => (
  <svg
    width={size === 'xs' ? 12 : 16}
    height={size === 'xs' ? 13 : 17}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6668 8.50009C14.6668 12.182 11.682 15.1668 8.00006 15.1668C4.31813 15.1668 1.33334 12.182 1.33334 8.50009C1.33334 4.81816 4.31813 1.83337 8.00006 1.83337C11.682 1.83337 14.6668 4.81816 14.6668 8.50009Z"
      stroke="#F59E0B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00024 3.87817C8.00024 3.60203 8.22464 3.37564 8.49947 3.40255C9.67459 3.51759 10.7798 4.03619 11.6219 4.87832C12.5825 5.83885 13.1221 7.14161 13.1221 8.5C13.1221 9.85839 12.5825 11.1611 11.6219 12.1217C10.7798 12.9638 9.67459 13.4824 8.49947 13.5975C8.22464 13.6244 8.00024 13.398 8.00024 13.1218L8.00024 8.5V3.87817Z"
      fill="#F59E0B"
    />
  </svg>
);

export const StatementInReviewIcon = ({ size }: IconProps) => (
  <svg
    width={size === 'xs' ? 12 : 16}
    height={size === 'xs' ? 13 : 17}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6668 8.50009C14.6668 12.182 11.682 15.1668 8.00006 15.1668C4.31813 15.1668 1.33334 12.182 1.33334 8.50009C1.33334 4.81816 4.31813 1.83337 8.00006 1.83337C11.682 1.83337 14.6668 4.81816 14.6668 8.50009Z"
      stroke="#0284C7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00025 3.88001C8.00025 3.60386 8.22464 3.37747 8.49947 3.4044C9.33578 3.48633 10.1418 3.77319 10.8448 4.24288C11.6867 4.80547 12.343 5.60511 12.7305 6.54067C13.118 7.47622 13.2194 8.50568 13.0219 9.49887C12.8243 10.4921 12.3367 11.4043 11.6206 12.1204C10.9046 12.8364 9.99229 13.3241 8.99911 13.5216C8.00593 13.7192 6.97647 13.6178 6.04091 13.2303C5.10535 12.8427 4.30572 12.1865 3.74312 11.3445C3.27343 10.6416 2.98657 9.83553 2.90464 8.99923C2.87772 8.7244 3.10411 8.5 3.38025 8.5H7.50025C7.77639 8.5 8.00025 8.27615 8.00025 8V3.88001Z"
      fill="#0284C7"
    />
  </svg>
);

export const StatementPublishedIcon = ({ size }: IconProps) => (
  <svg
    width={size === 'xs' ? 12 : 16}
    height={size === 'xs' ? 13 : 17}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.833344 8.50009C0.833344 4.54202 4.04199 1.33337 8.00006 1.33337C11.9581 1.33337 15.1668 4.54202 15.1668 8.50009C15.1668 12.4582 11.9581 15.6668 8.00006 15.6668C4.04199 15.6668 0.833344 12.4582 0.833344 8.50009ZM11.3536 7.18696C11.5489 6.9917 11.5489 6.67512 11.3536 6.47986C11.1584 6.2846 10.8418 6.2846 10.6465 6.47986L7.33339 9.793L6.02026 8.47987C5.825 8.28461 5.50842 8.28461 5.31316 8.47987C5.11789 8.67513 5.11789 8.99172 5.31316 9.18698L6.97983 10.8537C7.0736 10.9474 7.20078 11.0001 7.33339 11.0001C7.466 11.0001 7.59317 10.9474 7.68694 10.8537L11.3536 7.18696Z"
      fill="#16A34A"
    />
  </svg>
);
